import { Preloader as BasePreloader } from '@ezugi/ui/components';
import {
  PreloaderHeaderProps,
  PreloaderProps as BasePreloaderProps,
} from '@ezugi/ui/components/Preloader/Preloader';

import { UsePreloaderOptions, usePreloader } from './usePreloader';

export type PreloaderProps = {
  className?: string;
  options?: UsePreloaderOptions;
  components?: {
    Spinner?: BasePreloaderProps['spinner'];
    Image?: PreloaderHeaderProps['imageComponent'];
  };
};

const Preloader = ({ className, options, components }: PreloaderProps) => {
  const preloader = usePreloader(options);

  return (
    <BasePreloader
      {...preloader.boPreloaderConfig}
      className={className}
      playLabel={preloader.playLabel}
      isTapToPlayVisible={preloader.isTapToPlayVisible}
      isLoading={preloader.isLoading}
      show={preloader.show}
      onMount={preloader.onMount}
      onPlay={preloader.onPlay}
      onDestroy={preloader.onDestroy}
      spinner={components?.Spinner}
    >
      <BasePreloader.Header
        image={preloader.boPreloaderConfig.image}
        poweredBy={preloader.boPreloaderConfig.poweredBy}
        infoText={preloader.infoMessage}
        imageComponent={components?.Image}
        showInfoMessage={preloader.boPreloaderConfig.showInfoMessage}
      >
        <BasePreloader.GameDetails
          {...preloader.boPreloaderConfig}
          gameName={preloader.localeGameName}
        />
      </BasePreloader.Header>
      <BasePreloader.Footer />
    </BasePreloader>
  );
};

export default Preloader;
